export default __webpack_public_path__ + "static/newpl-5ac8833f14cf5d43b78bdc2dfd619c9d.jpg";